import { render } from "./Scheme.vue?vue&type=template&id=a934c778&scoped=true"
import script from "./Scheme.vue?vue&type=script&lang=js"
export * from "./Scheme.vue?vue&type=script&lang=js"

import "./Scheme.vue?vue&type=style&index=0&id=a934c778&scoped=true&lang=css"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a934c778"]])

export default __exports__